import { decodeObject, encodeObject } from 'utils/encoding/encoding';
import zoid from 'zoid';

export function getEnvFromUrl(url) {
  if (url.includes('payment-dev')) {
    const matches = url.match(/payment-dev-(.+?)\.flywire\.cc/);
    return matches ? matches[1] : 'local';
  }

  if (url.includes('flywire.lol')) {
    return 'staging';
  }

  if (url.includes('demo.flywire.com')) {
    return 'demo';
  }

  if (url.includes('flywire.com')) {
    return 'production';
  }

  return 'local';
}

if (!window.flywire) {
  const embedded = zoid.create({
    tag: 'fw-payment',
    dimensions: {
      width: '100%',
      height: '800px',
    },
    url: config => {
      const urls = {
        demo: 'https://payment.demo.flywire.com/',
        local: 'http://localhost:5300/',
        app: 'http://payex:5300/',
        production: 'https://payment.flywire.com/',
        staging: 'https://payment.flywire.lol',
      };

      const { props } = decodeObject(config);
      return urls[props.env] || `https://payment-dev-${props.env}.flywire.cc`;
    },
    defaultEnv: 'demo',
    scrolling: true,
    defaultLogLevel: 'error',
  });

  const embeddedAdapter = {
    Payment: {
      render: (config, selector) => {
        const encodedConfig = encodeObject(config);

        return embedded(encodedConfig).render(selector);
      },
      getEnvFromUrl: getEnvFromUrl,
    },
  };

  window.flywire = embeddedAdapter;
  window.requester = 'payex';
}
